import React, { useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import Home1 from './Home1';
import Home2 from './Home2';
import { useNavigate } from 'react-router-dom';

const Home = () => {

  const userRole = useMemo(() => {
    try {
      const user = JSON.parse(localStorage.getItem('userDetails'));
      return user?.data?.user?.role || null;
    } catch (err) {
      return null;
    }
  }, []);
  const navigate = useNavigate();
/*
useEffect(() => {
  const userDetails = localStorage.getItem('authToken');

  if (!userDetails) return;

  const updateShown = localStorage.getItem('newUpdateShown');

  if (updateShown) return;

  localStorage.setItem('newUpdateShown', 'true');

  const userinfo = JSON.parse(
    localStorage.getItem("userDetails")
  );

  const userName =
    userinfo?.data?.user?.name || "User";

  Swal.fire({
    // your complete Swal code here
  }).then((result) => {
    if (result.isConfirmed) {
      navigate("/app-profile");
    }
  });

}, []);
*/


  const allowedRoles = ['storeKeeper', 'admin', 'superAdmin', 'director', 'pomaker', 'pochecker', 'accounts', 'billing'];

  return allowedRoles.includes(userRole) ? <Home2 /> : <Home1 />;


};

export default Home;